export const MODEL__NAME__ACCOUNT = 'Account';
export const MODEL__NAME__CANDIDATE = 'Candidate';
export const MODEL__NAME__COMPANY = 'Company';
export const MODEL__NAME__EMPLOYER = 'Employer';
export const MODEL__NAME__ENGAGEMENT = 'Engagement';
export const MODEL__NAME__JOB = 'Job';
export const MODEL__NAME__RECRUITER = 'Recruiter';
export const MODEL__NAME__SCHOOL = 'School';